<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryVolumesByGroupIdList" :height="500">
    </Table>
  </div>
</template>
<script>
    var tableVolume = {}
    export default {
        name: 'TableVolume',
        data() {
            return {
                Name: '',
                modalLoading: false,
              columns: [
                {
                  title: '名称',
                  key: 'name'
                },
                {
                  title: '实例ID',
                  key: 'volumeAwsId'
                },
                {
                  title: '设备名',
                  key: 'deviceName'
                },
                {
                  title: '卷ID',
                  key: 'volumeAwsId'
                },
                {
                  title: '容量',
                  key: 'capacity'
                },
                {
                  title: this.$t('alarms.common.scanType'),
                  key: 'type'
                },
                {
                  title: '读取速度',
                  key: 'iops'
                },

                {
                  title: '地区',
                  key: 'region'
                },
              ],
              queryVolumesByGroupIdList: []
            }
        },
        beforeCreate: function () {
          tableVolume = this
        },
        mounted: function () {
          tableVolume.queryInstancesByGroupId()
        },
        methods: {
          queryInstancesByGroupId: function () {
            this.modalLoading = true
            tableVolume.$api.alertRule.selectInstantiationByAlertRule('id', this.$route.query.id)
              .then(res => {
                this.queryVolumesByGroupIdList = res.data[0].volumeList;
                this.modalLoading = false
              })
              .catch(res => {
                // 如果列表里没数据 返回
                this.queryVolumesByGroupIdList = undefined
              })
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rule_engine/TableVolume.vue